import NavBar from "./components/navBar";
import Profile from "./components/profile";
import Footer from "./components/footer";

const DashBoard = () =>{
    return (
        <>
            <NavBar/>
            <Profile/>
            <Footer/>
        </>
    )
}
export default DashBoard;